"use client";

import "@soprisapps/schoolblocks/src/scss/_error.scss";
import "@soprisapps/schoolblocks/src/scss/_reset.scss";
import ErrorPage from "@soprisapps/components/pages/ErrorPage";

export default function Error() {
  return (
    <html>
      <body>
        <ErrorPage />
      </body>
    </html>
  );
}
